export default __webpack_public_path__ + "static/lightning_b.e547f7d91abf6930b7fd0dc394359d37.png";